var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-action',{attrs:{"name":_vm.name}},[_c('v-input-color',{attrs:{"size":"sm","model":_vm.model},on:{"input":_vm.onInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }